export function normalizeBlacklistPhone(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits.length < 10) return null;
  return digits.slice(-10);
}

export function formatBlacklistPhone(phone) {
  const p = String(phone || '');
  if (p.length === 10) return `${p.slice(0, 3)} ${p.slice(3, 6)} ${p.slice(6)}`;
  return p;
}

export function coerceBlacklistEntries(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((item) => {
      if (item && typeof item === 'object' && !Array.isArray(item)) {
        const phone = normalizeBlacklistPhone(item.phone ?? item);
        if (!phone) return null;
        return {
          phone,
          name: String(item.name || item.label || '').trim().slice(0, 80),
        };
      }
      const phone = normalizeBlacklistPhone(item);
      if (!phone) return null;
      return { phone, name: '' };
    })
    .filter(Boolean);
}
